<template>
  <div class="descriptions flex-1 w-full h-35px leading-35px">
    <span class="text-16px text-white ml-15px font-bold">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.descriptions {
  background: url('../../../assets/images/metal/titleBG.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
</style>
